module.exports = __webpack_public_path__ + "img/2x.cf58c67.jpg";